import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { kpiAPI } from '../../services/api';

export const fetchKPIDashboard = createAsyncThunk(
  'kpi/fetchDashboard',
  async () => {
    const response = await kpiAPI.getDashboard();
    return response.data;
  }
);

export const fetchKPICategories = createAsyncThunk(
  'kpi/fetchCategories',
  async () => {
    const response = await kpiAPI.getCategories();
    return response.data;
  }
);

export const fetchKPIScores = createAsyncThunk(
  'kpi/fetchScores',
  async (params = {}) => {
    const response = await kpiAPI.getScores(params);
    return response.data;
  }
);

export const fetchKPIRanking = createAsyncThunk(
  'kpi/fetchRanking',
  async (params = {}) => {
    const response = await kpiAPI.getRanking(params);
    return response.data;
  }
);

export const createKPIScore = createAsyncThunk(
  'kpi/createScore',
  async (data, { rejectWithValue }) => {
    try {
      const response = await kpiAPI.createScore(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateKPIScore = createAsyncThunk(
  'kpi/updateScore',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await kpiAPI.updateScore(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const calculateKPI = createAsyncThunk(
  'kpi/calculate',
  async (data) => {
    const response = await kpiAPI.calculate(data);
    return response.data;
  }
);

const kpiSlice = createSlice({
  name: 'kpi',
  initialState: {
    dashboard: null,
    categories: [],
    scores: [],
    ranking: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKPIDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchKPIDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboard = action.payload;
      })
      .addCase(fetchKPIDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchKPICategories.fulfilled, (state, action) => {
        state.categories = action.payload.results || action.payload;
      })
      .addCase(fetchKPIScores.fulfilled, (state, action) => {
        state.scores = action.payload.results || action.payload;
      })
      .addCase(fetchKPIRanking.fulfilled, (state, action) => {
        state.ranking = action.payload;
      })
      .addCase(createKPIScore.fulfilled, (state, action) => {
        state.scores.push(action.payload);
      })
      .addCase(updateKPIScore.fulfilled, (state, action) => {
        const index = state.scores.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.scores[index] = action.payload;
        }
      });
  },
});

export const { clearError } = kpiSlice.actions;
export default kpiSlice.reducer;
